<template>
  <v-btn color="warning" @click="transfer()">移譲</v-btn>
</template>

<script>
export default {
  props: {
    subscriptionId: {
      type: String,
      default: "",
    },
    childUserId: {
      type: String,
      default: "",
    },

    routes: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      localSubscriptionId: this.subscriptionId,
      localChildId: this.childUserId,
      localSwitchAdminBaseRoute: this.routes.switchAdminBaseRoute,
    };
  },

  methods: {
    transfer() {
      if (
        window.confirm(
          "定額受講コンテンツのeラーニング管理権限を移譲します。よろしいですか?\n権限を移譲すると以下の機能・情報が移行されます。\n\n・会員解約機能\n・決済情報",
        )
      ) {
        const url = new URL(
          this.localSwitchAdminBaseRoute,
          window.location.origin,
        );

        url.searchParams.append("subscription_id", this.localSubscriptionId);
        url.searchParams.append("child_id", this.localChildId);

        window.location.href = url.toString();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 750px) {
  .v-btn {
    min-width: 60px !important;
    margin: inherit;
  }
}
</style>
